import { Provider } from '@angular/core';
import { payoutDetailsEnabled } from '@bcf-v2-configurators/tokens/betslip/lvbetcom/payout-details-enabled';
import { PAYOUT_DETAILS_ENABLED } from '@bcf-v2-configurators/tokens/betslip/token';
import { forceBackToCurrentLocation } from '@bcf-v2-configurators/tokens/cashier/mobile-web-twa/force-back-to-current-location';
import { FORCE_BACK_TO_CURRENT_LOCATION } from '@bcf-v2-configurators/tokens/cashier/token';
import { COMMISSION_ENABLED } from '@bcf-v2-configurators/tokens/my-bets/token';
import { shareBetHost } from '@bcf-v2-configurators/tokens/share-bet/lvbetcom/share-bet-host';
import { SHARE_BET_HOST } from '@bcf-v2-configurators/tokens/share-bet/token';
import { TWA_IN_APP_REVIEW_CONFIG_LOADER } from '@bcf-v2-configurators/tokens/twa-in-app-review/tokens';

export const settingsProviders: Provider[] = [
  {
    provide: FORCE_BACK_TO_CURRENT_LOCATION,
    useValue: forceBackToCurrentLocation
  },
  {
    provide: PAYOUT_DETAILS_ENABLED,
    useValue: payoutDetailsEnabled
  },
  {
    provide: SHARE_BET_HOST,
    useValue: shareBetHost
  },
  {
    provide: TWA_IN_APP_REVIEW_CONFIG_LOADER,
    useValue: () =>
      import('@bcf-v2-configurators/tokens/twa-in-app-review/lvbetcom/sportsbook/mobile-web-twa/twa-in-app-review-config').then(
        // eslint-disable-next-line @typescript-eslint/typedef
        (mod) => mod.twaInAppReviewConfig
      )
  },
  {
    provide: COMMISSION_ENABLED,
    useValue: false
  }
];
